import { useState } from "react";

/**
 * Renders a review text with optional truncation and a "Weiterlesen" toggle.
 * Cards stay roughly the same height; long reviews can be expanded inline.
 */
export default function ReviewText({
  text,
  threshold = 260,
  className = "",
  buttonClassName = "",
  showMoreLabel = "Weiterlesen",
  showLessLabel = "Weniger anzeigen",
}) {
  const [expanded, setExpanded] = useState(false);
  const isLong = text && text.length > threshold;
  // Cut at last word boundary before threshold
  let shown = text;
  if (!expanded && isLong) {
    const slice = text.slice(0, threshold);
    const lastSpace = slice.lastIndexOf(" ");
    shown = (lastSpace > threshold - 40 ? slice.slice(0, lastSpace) : slice).trimEnd() + "…";
  }
  return (
    <>
      <span className={className}>&ldquo;{shown}&rdquo;</span>
      {isLong && (
        <button
          type="button"
          onClick={() => setExpanded(!expanded)}
          className={`ml-1 underline-offset-2 hover:underline transition-colors ${buttonClassName}`}
        >
          {expanded ? showLessLabel : showMoreLabel}
        </button>
      )}
    </>
  );
}
